import { NativeModules, Platform } from "react-native";
import { serializeRulesForNative } from "../blocking/rulesEngine";

const ST = Platform.OS === "android" ? NativeModules.ScreenTimeControl : null;

export function androidScreenTimeSupported() {
  return !!ST;
}

export function buildVpnRulesPayload(blockedList, allowedList, keywordBlockList, categoryRules = {}, extras = {}) {
  return serializeRulesForNative({
    block: blockedList || [],
    allow: allowedList || [],
    keywords: keywordBlockList || [],
    categoryRules,
    safeMode: extras.safeMode !== false,
  });
}

export function updateVpnRulesJson(jsonString) {
  if (!ST?.updateVpnRulesJson || typeof jsonString !== "string") return;
  ST.updateVpnRulesJson(jsonString);
}

export async function syncVpnRulesToNative(blockedList, allowedList, keywordBlockList, categoryRules = {}) {
  if (!ST?.updateVpnRulesJson) return;
  ST.updateVpnRulesJson(buildVpnRulesPayload(blockedList, allowedList, keywordBlockList, categoryRules));
}

export async function startDnsVpn() {
  if (!ST?.startDnsVpn) throw new Error("DNS VPN not available");
  return ST.startDnsVpn();
}

export async function stopDnsVpn() {
  if (!ST?.stopDnsVpn) throw new Error("DNS VPN not available");
  return ST.stopDnsVpn();
}

export async function isDnsVpnRunning() {
  if (!ST?.isDnsVpnRunning) return false;
  try {
    return await ST.isDnsVpnRunning();
  } catch {
    return false;
  }
}

export async function hasUsageStatsPermission() {
  if (!ST?.hasUsageStatsPermission) return false;
  try {
    return await ST.hasUsageStatsPermission();
  } catch {
    return false;
  }
}

export function openUsageAccessSettings() {
  ST?.openUsageAccessSettings?.();
}

export async function getTodayUsageMs(packageName) {
  if (!ST?.getTodayUsageMs) return 0;
  const v = await ST.getTodayUsageMs(packageName);
  return typeof v === "number" ? v : 0;
}

export function showLimitOverlay(title, message) {
  ST?.showLimitOverlay?.(title || "Time limit", message || "");
}

export async function canDrawOverlays() {
  if (!ST?.canDrawOverlays) return true;
  try {
    return await ST.canDrawOverlays();
  } catch {
    return true;
  }
}

export function requestOverlayPermission() {
  ST?.requestOverlayPermission?.();
}
